import React from 'react';
import CardHeader from '@mui/material/CardHeader';

const ReportsCardHeader = ({ title, icon, subheader = null }) => {
    return (
        <CardHeader
            sx={{
                m: 0,
                py: 1,
                '& .MuiCardHeader-action': {
                    alignSelf: 'center'
                }
            }}
            slotProps={{
                title: {
                    variant: 'h6',
                    fontWeight: 'normal'
                }
            }}
            avatar={icon}
            title={title}
            subheader={subheader ?? undefined}
        />
    );
};

export default ReportsCardHeader;